import { Component, Input, OnInit } from '@angular/core';
import { AssetImage } from 'src/app/model/shared/asset-image';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-iag-portal-accordian-section',
  templateUrl: './iag-portal-accordian-section.component.html',
  styleUrls: ['./iag-portal-accordian-section.component.scss']
})
export class IagPortalAccordianSectionComponent implements OnInit {
  @Input() expandImages: AssetImage[] = [];
  @Input() accordianSections: Section[] = [];
  collapsed: boolean[] = [];
  constructor() {}

  ngOnInit(): void {
    this.expandImages?.forEach((i) => {
      this.collapsed.push(false);
    });
  }

  toggleCollapsed(index: number) {
    this.collapsed[index] = !this.collapsed[index];
  }

  getAccordionStyle(index: number) {
    return this.collapsed[index] ? 'not-collapsed' : 'collapsed';
  }

  getActiveStyle(index: number) {
    return this.collapsed[index] ? 'active' : 'title-hover';
  }

  getArrowIcons(index: number) {
    return this.collapsed[index] ? 'icon-arrowUp' : 'icon-arrowDown';
  }
}
